<div class="card mt-3">
  <div class="card-header d-flex align-items-center">
    <h5 class="mb-0">Bases</h5>

    <div class="ms-auto">
      <button class="btn btn-primary" (click)="updateProjectStage()">
        <fa-icon class="button-icon-left" [icon]="faArrowRight"></fa-icon>
        <span>Next Stage</span>
      </button>
    </div>
  </div>

  <div class="card-body">
    <!-- Add new base -->
    <div class="input-group">
      <input
        id="NEW_PROJECT_BASE"
        type="text"
        class="form-control"
        placeholder="Did you follow up with the client?"
      />
      <button type="button" class="btn btn-outline-primary" (click)="addProjectBase()">
        <fa-icon [icon]="faCheck"></fa-icon>
      </button>
    </div>

    <!-- Bases list -->
    <div
      *ngFor="let base of bases; trackBy: trackByBaseId; index as i"
      class="input-group mt-2"
    >
      <!-- Checkbox -->
      <div class="input-group-text">
        <input
          type="checkbox"
          class="form-check-input mt-0"
          (change)="toggleBaseCompletion(base, $any($event.target).checked)"
          [checked]="base.isComplete"
        />
      </div>

      <!-- Content -->
      <input
        type="text"
        class="form-control"
        [value]="base.content"
        (input)="projectBaseEdited(base, $event)"
      />
      <!-- Completed By -->
      <span *ngIf="base.isComplete" class="input-group-text">Completed By</span>
      <input
        *ngIf="base.isComplete"
        type="text"
        class="form-control"
        style="max-width: 220px;"
        [value]="base.updatedBy ? (base.updatedBy.firstName + ' ' + base.updatedBy.lastName) : ''"
        readonly
      />

      <!-- Time -->
      <span *ngIf="base.isComplete" class="input-group-text">Time</span>
      <input
        *ngIf="base.isComplete"
        type="text"
        class="form-control"
        style="max-width: 230px;"
        [value]="base.lastUpdated ? (base.lastUpdated * 1000 | date: 'MMM d, y, h:mm a') : ''"
        readonly
      />

      <!-- Delete -->
      <button
        type="button"
        class="btn btn-outline-danger"
        style="width: 40px;"
        (click)="deleteProjectBase(base)"
      >
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
  </div>
</div>
